import React from 'react'

const SvgLabBeakerFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M12.982 5h-1.964v4.493c0 .665-.163 1.32-.474 1.905h2.912a4.057 4.057 0 01-.474-1.905V5zM9 3s-1-.037-1 1c0 1 1.053 1 1.053 1v4.493c0 .333-.081.66-.237.953L4.24 18.047C3.53 19.38 4.479 21 5.967 21h12.066c1.488 0 2.436-1.62 1.727-2.953l-4.576-7.601a2.029 2.029 0 01-.237-.953V5S16 5 16 4s-1.053-1-1.053-1H9z'
    />
  </svg>
)

export default SvgLabBeakerFilled
